import { render, staticRenderFns } from "./zhenTi.vue?vue&type=template&id=209584c8&scoped=true&"
import script from "./zhenTi.vue?vue&type=script&lang=js&"
export * from "./zhenTi.vue?vue&type=script&lang=js&"
import style0 from "./zhenTi.vue?vue&type=style&index=0&id=209584c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209584c8",
  null
  
)

export default component.exports